import Box from '@mui/material/Box';
import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { useDispatch } from 'react-redux';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import CssBaseline from '@mui/material/CssBaseline';

import { displayError } from '../../helpers';
import { userActions } from '../../store/actions';
import useStyles from './Styles/AccountFormStyles';
import { validatePasswordReset } from '../../validations';
import { Footer, Header, PasswordInput, ShowSpinnerOrLabel } from '../../components';

export function ResetPassword() {
    const classes = useStyles();
    const dispatch = useDispatch();
    let token = window.location.pathname.split("/")[2];

    const [resetInProgress, setResetInProgress] = useState(false);
    const [errors, setErrors] = useState({});

    const onSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const state = {
            password: data.get('password'),
            confirmPassword: data.get('confirmPassword'),
        }
        const errors = validatePasswordReset(state);

        if (Object.keys(errors).length) {
            setErrors(errors);
            return
        }
        setErrors({});
        setResetInProgress(true);
        const payload = {
            token,
            password: data.get('password'),
            password_confirmation: data.get('confirmPassword'),
        };
        dispatch(userActions.passwordReset(payload));
    };

    useEffect(() => {
        dispatch(userActions.validatePasswordResetToken(token));
    }, [])

    return (
        <React.Fragment>
            <Header />
            <Container className={classes.mainContainer}>
                <Container component="main" maxWidth="sm" className={classes.formOuter}>
                    <CssBaseline />
                    <Box className={classes.formContainer}>
                        <Box component="form" onSubmit={onSubmit} noValidate sx={{ mt: 1 }}>

                            <Typography gutterBottom align='center' component="h1" variant="h5" className={classes.formHeading}>
                                Reset Password
                            </Typography>
                            <PasswordInput
                                id="password"
                                name="password"
                                label="Password"
                                margin="normal"
                                error={displayError(errors.password)}
                                helpertext={errors.password}
                                tabIndex="1"
                                fullWidth
                                required
                            />
                            <PasswordInput
                                id="confirmPassword"
                                name="confirmPassword"
                                label="Confirm Password"
                                margin="normal"
                                error={displayError(errors.confirmPassword)}
                                helpertext={errors.confirmPassword}
                                tabIndex="2"
                                fullWidth
                                required
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                disabled={resetInProgress}
                                sx={{ mt: 3, mb: 2 }}
                            >
                                <ShowSpinnerOrLabel label="Reset" loading={resetInProgress} variant='white' />
                            </Button>
                        </Box>
                    </Box>
                </Container>
            </Container>
            <Footer />
        </React.Fragment>
    );
}